export const navbarItems = [
  { name: 'HJEM', path: '/grupper/D05-23' },
  { name: 'OM OSS', path: '/grupper/D05-23/omoss' },
  { name: 'PROTOTYPE', path: '/grupper/D05-23/prototype'},
  { name: 'DIREKTE', path: '/grupper/D05-23/live'}
];
export const navDocItems = [
  { name: 'Rapport', path:'*', target: '_blank', id: 4},
];
